import I18nForLwText from './LwText'

/**
 * Lw-Select 的判断逻辑和lw-text 组件一致
 */
export default class I18nForLwChoice extends I18nForLwText {
  name = 'lw-choice'
}
